// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1FCov","file":"styles_file__CSVFW"};